import {
  GroupContextSchemaData,
  PostContextSchemaData,
  UserContextSchemaData,
} from '../schema'
import { trackEvent } from './helper'

type PostEventParams = {
  post: PostContextSchemaData
  group?: GroupContextSchemaData
}

type PostUserEventParams = PostEventParams & { user?: UserContextSchemaData }

export const draft_post = (props: { group?: GroupContextSchemaData } = {}) =>
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'draft_post',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })

export const create_post = (props: PostEventParams) =>
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'create_post',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })

export const like_post = (props: PostEventParams) =>
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'like_post',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })

export const gift_post = (props: PostEventParams) =>
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'gift_post',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })

export const reply_post = (props: PostEventParams) =>
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'reply_post',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })

export const repost_post = (props: PostEventParams) =>
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'repost_post',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })

export const report_post = (props: PostUserEventParams) =>
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'report_post',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })

export const open_profile = (props: PostUserEventParams) =>
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'open_profile',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })

export const see_conversation = (props: PostUserEventParams) =>
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'see_conversation',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })
